import PubSub from "underpub-js";

var SplashPageStyleFour = function (options) {
    this.options = {
        $el: false,
        baseClass: "mol-SplashPageStyleFour",
    };

    $.extend(true, this.options, options);
};

SplashPageStyleFour.prototype.init = function () {
    var self = this;

    // Attach click event handler to the button with class '.atom-ButtonPrimary'
    $(document).on("click", ".atom-ButtonPrimary", function () {
        // Toggle the 'modalFormIsOn' class on the body element
        $("body").addClass("modalFormIsOn");
    });

    // Attach click event handler to the button with class '.atom-ButtonIcon'
    $(document).on("click", ".atom-ButtonIcon", function () {
        // Remove the 'modalFormIsOn' class from the body element
        $("body").removeClass("modalFormIsOn");
    });
};

export default SplashPageStyleFour;
